import { aiCollectionFilterIds } from "./aiArtworkCatalog";
import {
  aiDescriptionFromFile,
  aiTitleFromFile,
} from "./aiArtworkTranslations";

export { aiCollectionFilterIds };

export function descriptionFromFile(
  imageFile: string,
  lang: "en" | "he",
): string {
  return aiDescriptionFromFile(imageFile, lang);
}

export function titleFromFileEn(imageFile: string): string {
  return aiTitleFromFile(imageFile, "en");
}

export function titleFromFileHe(imageFile: string): string {
  return aiTitleFromFile(imageFile, "he");
}
